import React, { useState, useRef } from "react";
import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";

//CSS
import "./emailContactBox.css";
//Components
import Button from "../Other Components/button";
import InputField from "../Other Components/inputField";
//Animations
import { motion } from "framer-motion";
import { slideInOnScrollLeft } from "../Other Components/animations";

export default function EmailContactBox() {
  const { t } = useTranslation("home");
  const form = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", text: "" });

  // Handle input changes
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // Validate form
  const validateForm = () => {
    if (!formData.name.trim()) {
      setStatus({ type: "error", text: t("contactBox.validation.enterName") });
      return false;
    }
    if (!formData.email.trim()) {
      setStatus({ type: "error", text: t("contactBox.validation.enterEmail") });
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setStatus({ type: "error", text: t("contactBox.validation.validEmail") });
      return false;
    }
    if (!formData.message.trim()) {
      setStatus({
        type: "error",
        text: t("contactBox.validation.enterMessage"),
      });
      return false;
    }
    return true;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    setStatus({ type: "", text: "" });

    try {
      await emailjs.send(
        "service_smzqiyg",
        "template_3pw2bta",
        { ...formData },
        "rx-v_FdaaxqwohFzm"
      );
      setStatus({ type: "success", text: t("contactBox.status.success") });
      setFormData({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      console.error("Failed to send email:", error);
      setStatus({ type: "error", text: t("contactBox.status.error") });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={slideInOnScrollLeft("100%", 0.3)}
      className="contactContainer"
    >
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={slideInOnScrollLeft("100%", 0.3)}
        className="contactText"
      >
        <p className="contactParagraph">{t("contactBox.prompt1")}</p>
        <p className="contactParagraph">{t("contactBox.prompt2")}</p>
      </motion.div>

      <form
        ref={form}
        onSubmit={handleSubmit}
        className="contactInputContainer"
      >
        <InputField
          placeholder={t("contactBox.name")}
          name="name"
          value={formData.name}
          onChange={(value) => handleInputChange("name", value)}
          required
        />
        <InputField
          placeholder={t("contactBox.email")}
          name="email"
          type="email"
          value={formData.email}
          onChange={(value) => handleInputChange("email", value)}
          required
        />
        <InputField
          placeholder={t("contactBox.phone")}
          name="phone"
          value={formData.phone}
          onChange={(value) => handleInputChange("phone", value)}
        />
        <InputField
          placeholder={t("contactBox.message")}
          name="message"
          largeField={true}
          value={formData.message}
          onChange={(value) => handleInputChange("message", value)}
          required
        />

        {status.text && (
          <div className={`status-message ${status.type}`}>{status.text}</div>
        )}

        <Button className="contactButton" type="submit" disabled={isLoading}>
          {isLoading ? t("contactBox.sending") : t("contactBox.send")}
        </Button>
      </form>
    </motion.div>
  );
}
